import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["datemask", "timemask", "grillemask", "swappersonnetype"]
  //data-utility-target
  static values = {
    uid: String,
    url: String
  }
  // Called when the controller connects to the DOM
  connect() {
    // Code here runs when the page loads
    this.utilityInstances = []
    this.initializeUtilities()
    this.binds_key_to_RAMQ_guides()
    this.setupObserver()    
  }

  disconnect() {
    this.utilityInstances = []

    if (this.observer) {
      this.observer.disconnect()
    }    
  }  

  // Functions you want available for direct call
  initializeUtilities() {
    this.datemaskTargets.forEach(element => {
      this.initializeDateMask(element)
    })
    this.timemaskTargets.forEach(element => {
      this.initializeTimeMask(element)
    })
    this.grillemaskTargets.forEach(element => {
      this.initializeGrilleMask(element)
    })
    this.swappersonnetypeTargets.forEach(element => {
      this.initializeSwapPersonneType(element)
    })
  }

  initializeDateMask(element){
    if (this.isElementInitialized(element)) {return;}
    $(element).mask('0000-00-00')
    // Store the instance and configuration for later reference
    this.utilityInstances.push({ element: element})
  }

  initializeTimeMask(element){
    if (this.isElementInitialized(element)) {return;}
    $(element).mask("Hh:Mm", {
      translation: {
     'H': {
        pattern: /[0-2]/,
        optional: true
           },
     'h': {
        pattern: /[0-9]/,
        optional: false
           },
     'M': {
       pattern: /[0-5]/,
       optional: false
     },
     'm': {
       pattern: /[0-9]/,
       optional: false
     }
    }});
    // Store the instance and configuration for later reference  
    this.utilityInstances.push({ element: element})
  }

  initializeGrilleMask(element){
    if (this.isElementInitialized(element)) {return;}
    element.addEventListener('keypress', function(event) {
      var value = String.fromCharCode(event.which);
      var pattern = new RegExp(/[a-zA-Z0-9h#%:,-<_]/i);
      return pattern.test(value);
    });
    // Store the instance and configuration for later reference
    this.utilityInstances.push({ element: element})    
  }

  initializeSwapPersonneType(element){
    if (this.isElementInitialized(element.selectize)) {return;}
    const $selectElement = $(element);
    element.selectize.on("change", function(elementSelectize) {
      const currentValue = this.getValue();
      const $parentForm = $selectElement.closest(".facture-personne-simpleform");
      if (currentValue != 'PersonneAutre'){
        $parentForm.find(".autre-affichage").hide();
        $parentForm.find(".patient-affichage").show();
        $parentForm.find('.autre-affichage').prop('disabled',true);
        $parentForm.find('.patient-affichage').prop('disabled',false);
      }else if(currentValue == 'PersonneAutre'){
        $parentForm.find(".autre-affichage").show();
        $parentForm.find(".patient-affichage").hide();
        $parentForm.find('.autre-affichage').prop('disabled',false);
        $parentForm.find('.patient-affichage').prop('disabled',true);
      }
    });
    // Store the instance and configuration for later reference
    this.utilityInstances.push({ element: element.selectize})
  }  

  isElementInitialized(element) {
    // Check if the element is already in the instances array
    return this.utilityInstances.some(instance => 
      instance.element === element
    )
  }    

  setupObserver() {
    // Create a new MutationObserver
    this.observer = new MutationObserver(mutations => {
      let needsInitialization = false
      
      // Check if any mutations added nodes to the DOM
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          needsInitialization = true
          break
        }
      }

      if (needsInitialization) {
        this.initializeUtilities()
      }
    })
    // Start observing the entire element that contains this controller
    this.observer.observe(this.element, {
      childList: true,
      subtree: true
    })
  }    

  binds_key_to_RAMQ_guides(){
    // Ouverture du manuel de facturation avec F1 et F2
    $(document).keydown(function(e) {
      if(e.which == 112 ) {
        e.preventDefault();
        var wnd = window.open("https://www.ramq.gouv.qc.ca/fr/professionnels/medecin-omnipraticien-omnipraticienne/manuels-guides/manuel-remuneration-acte");
      }
      if(e.which == 113 ) {
        e.preventDefault();
        var wnd = window.open("https://www.ramq.gouv.qc.ca/fr/professionnels/medecin-omnipraticien-omnipraticienne/manuels-guides/brochure-1-entente-generale");
      }
      if(e.which == 114 ) {
        e.preventDefault();
        var wnd = window.open("https://www.ramq.gouv.qc.ca/fr/professionnels/medecin-specialiste/manuels-guides");
      }
      if(e.which == 123 ) {
        e.preventDefault();
        $.ajax({
          method: 'GET',
          url: '/affichage_mutation',
          success: function(response){
            return;
          }
        });
      }
    });
  }

  // Functions that can be called via data-action
  selectAll(event) {
    this.checked = !this.checked;
    if(this.checked) {
      document.querySelectorAll('.checkbox-facture').forEach(function(checkbox) {
          checkbox.checked = true;
      });
    } else {
        document.querySelectorAll('.checkbox-facture').forEach(function(checkbox) {
            checkbox.checked = false;
        });
    }
  }

  calc_nb_suivis_simple(event){
    $.ajax({url: '/calc_nb_suivis_simple', type: 'GET'});
  }

  calc_nb_suivis_tous(event){
    $.ajax({url: '/calc_nb_suivis_tous', type: 'GET'});
  }

  impression_facture(event){
    event.preventDefault()
    const $src_element = event.srcElement.closest('a');
    const uid = parseInt($src_element.dataset.utilityUid);    
    var url = new URL("/impression_facture", window.location.origin);
    var notes = prompt("Ajouter une note à la facture?", "");

    $.ajax({
      url: '/impression_facture',
      type: 'GET',
      dataType : 'script',
      data: { utilisateur_id: uid,
              notes: notes}
    });
  }

  switch_mutation_affichage(event){
    event.stopPropagation();
    $.ajax({
      method: 'GET',
      url: '/affichage_mutation',
      success: function(response){
        window.location.reload();
      }
    });
  }
  
  mutation_admin_utilisateur(){
    var mutations = [];
    $('.checkbox-mutation:checked').each(function(){mutations.push(this.id)});
    var utilisateur_id = $('#mutation_change_dup_utilisateur_id').val();
    var profil_etablissement_id = $('#mutation_dup_profil_etablissement_id').val();
    var global = $('#dup_global_check').is(":checked");
    $.ajax({
      url: '/mutation_admin_utilisateur',
      type: 'POST',
      data: { authenticity_token: AUTH_TOKEN,
              mutations: mutations,
              utilisateur_id: utilisateur_id,
              profil_etablissement_id: profil_etablissement_id,
              global: global
            },
      success: function(response) {
       window.location.reload();
      }
    });
  }
  
  mutation_admin_etablissement(){
    var mutations = [];
    $('.checkbox-mutation:checked').each(function(){mutations.push(this.id)});
    var profil_etablissement_id = $('#mutation_rea_profil_etablissement_id').val();
    var global = $('#rea_global_check').is(":checked");
    $.ajax({
      url: '/mutation_admin_etablissement',
      type: 'POST',
      data: { authenticity_token: AUTH_TOKEN,
              mutations: mutations,
              profil_etablissement_id: profil_etablissement_id,
              global: global
            },
      success: function(response) {
       window.location.reload();
      }
    });
  }

  approuve_etat_compte(event){
    var IDs = [];
    const egalir = event.srcElement.dataset.utilityEgalir === 'true'
    $('.checkbox-facture:checked:not(#select-all-facture)').each(function(){IDs.push(this.id)});
    $.ajax({
        url: '/rfp/approuve_etat_compte',
        type: "POST",
        data: {authenticity_token: AUTH_TOKEN,
               IDs: IDs,
               redirect: '_etat_compte_path',
               prelim_egale_payer: egalir},
        success: function(response) {
         window.location.reload();
        }
    });
  }
  
  appliquer_reviseur(event){
    var IDs = [];
    $('.checkbox-facture:checked:not(#select-all-facture)').each(function(){IDs.push(this.id)});
    $.ajax({
        url: '/rfp/appliquer_reviseur',
        type: "POST",
        data: {authenticity_token: AUTH_TOKEN,
               IDs: IDs,
               redirect: '_etat_compte_path'},
        success: function(response) {
         window.location.reload();
        },
    });
  }
  
  visualiser_factures(event){
    var IDs = [];
    $('.checkbox-facture:checked:not(#select-all-facture)').each(function(){IDs.push(this.id)});
    IDs.forEach((id) => {
      var url = '/rfp/' + (id.slice(0, 4) + '_' + id.slice(4).replace('_', 's/')).toLowerCase();
      window.open(url, '_blank');
    });
  }
   
  reassigne_date(event){
    const specialite = event.srcElement.dataset.utilitySpecialite
    var facture_ids = [];
    $('.checkbox-facture:checked').each(function(){facture_ids.push(this.id)});
    var date = $('#date_service_d').val();
    $.ajax({
      url: '/reassigne_date',
      type: 'POST',
      data: { authenticity_token: AUTH_TOKEN,
              type_facture: specialite,
              facture_ids: facture_ids,
              date: date
            },
      success: function(response) {
       window.location.reload();
      }
    });
  }
  
  reassigne_etablissement(event){
    const specialite = event.params.value
    var facture_ids = [];
    $('.checkbox-facture:checked').each(function(){facture_ids.push(this.id)});
    var profil_etablissement_id = $('#reassigne_etablissement_id').val();
    $.ajax({
      url: '/reassigne_etablissement',
      type: 'POST',
      data: { authenticity_token: AUTH_TOKEN,
              type_facture: specialite,
              facture_ids: facture_ids,
              profil_etablissement_id: profil_etablissement_id
            },
      success: function(response) {
       window.location.reload();
      }
    });
  }

  extract_courriel(event) {
    event.stopPropagation();
    $.ajax({
      url: this.urlValue,
      type: 'POST',
      data: { authenticity_token: AUTH_TOKEN },
      success: function(response) {
        alert("L'extraction des courriels a été lancée en arrière-plan.");
      },
      error: function(xhr, status, error) {
        console.error("Erreur lors du lancement de l'extraction:", error);
      }
    });
  }
  
}